import { Component, OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef, OnChanges, TemplateRef, ViewChild} from '@angular/core';
import {DemoService} from '../../../demo.service';

import {Routes, RouterModule, Router} from '@angular/router';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';


import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';


// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {Observable, Subject, map , Subscription} from 'rxjs';

import { Location } from '@angular/common';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { HotToastService } from '@ngneat/hot-toast';

// Tabs
import { TabsetComponent, TabDirective } from 'ngx-bootstrap/tabs';

@Component({
  selector: 'app-create-job-type',
  templateUrl: './create-job-type.component.html',
  styleUrls: ['./create-job-type.component.css']
})
export class CreateJobTypeComponent implements OnInit {
  job_types: any;
  job_type_locations: any;
  job_type_courts: any;
  job_type_document_types: any;
  job_type_affidavit_types: any;
  modalRef: BsModalRef;
  model: any;
  // tslint:disable-next-line:member-ordering
  public static returned: Subject<any> = new Subject();
  addCourtClick: boolean;
  updateCourtClick: boolean;

initialCount = 10; // Put this in the master -> for child trace-candidate-update
public count;
  addDocumentClick: boolean;
  updateDocumentClick: boolean;
  addAffidavitClick: boolean;
  updateAffidavitClick: boolean;
  addLocationClick: boolean;
  updateLocationClick: boolean;
  addTypeClick: boolean;
  updateTypeClick: boolean;

  // page variables
  page: any;
  p_job_type_affidavit_types: number;
  page_c: number;
  page_job_types: any;


  // TABS
  // required for tab action events
  @Output() events  = new EventEmitter();
  // TABS sets the selected
  @ViewChild('staticTabs') staticTabs: TabsetComponent;
  @ViewChild('1') 1: TabDirective;
  @ViewChild('2') 2: TabDirective;
  activeTab: any;
  activeTabId: any;
  value: string;

  constructor(private http: HttpClient, private _demoService: DemoService,
    private route: ActivatedRoute, public toastr: HotToastService,
     vcr: ViewContainerRef, private router: Router,
     private modalService: BsModalService, viewRef: ViewContainerRef,
     private _location: Location) {


      CreateJobTypeComponent.returned.subscribe(res => {
// refresh types
this.getJobTypes();
this.addTypeClick = false;
this.updateTypeClick = false;

        // locations refresh
this.getJobTypeAllLocations();
this.addLocationClick = false;
this.updateLocationClick = false;
        // courts refresh
        this.getJobTypeAllCourts();
        this.addCourtClick = false;
        this.updateCourtClick = false;
// documents refresh
this.addDocumentClick = false;
this.updateDocumentClick = false;
this.getJobTypeAllDocumentTypes();
// affidavit refresh
this.addAffidavitClick = false;
this.updateAffidavitClick = false;
this.getJobTypeAllAffidavitTypes();


      });

      }

  ngOnInit(
  ) {
    this.getJobTypes();
    this.getJobTypeAllLocations();
    this.getJobTypeAllCourts();
    this.getJobTypeAllDocumentTypes();
    this.getJobTypeAllAffidavitTypes();
  }

// TABS component
/// TABS
selectTab(tab_id: number) {
  this.staticTabs.tabs[tab_id].active = true;
  // this.refreshList();
  // this.refreshGrid();
};


   // to router navigate back
public goBack() {
  this._location.back();
}

// when a tab button is pressed an event is sent.
public changeTab($event) {
  this.activeTab = $event.heading;
  this.activeTabId = $event.id;
  if (this.activeTabId === 2) {
    // this.loadList(this.doc_id);
    console.log('File List Loaded');
}
}

tabSelect(data: TabDirective): void {
  this.value = data.heading;
  // this.loadList(this.doc_id);
  console.log(this.value);
  if (this.value === 'Browse Server') {
    console.log('File List Loaded');
}
}


  
 // MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  this.modalRef = this.modalService.show(template);
}


  getJobTypes() {
    this._demoService.getJobTypes().subscribe(
       data => { this.job_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  

   getJobTypeAllLocations() {
    this._demoService.getJobTypeAllLocations().subscribe(
       data => { this.job_type_locations = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }


   getJobTypeAllCourts() {
    this._demoService.getJobTypeAllCourts().subscribe(
       data => { this.job_type_courts = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  

   getJobTypeAllDocumentTypes() {
    this._demoService.getJobTypeAllDocumentTypes().subscribe(
       data => { this.job_type_document_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  

   getJobTypeAllAffidavitTypes() {
    this._demoService.getJobTypeAllAffidavitTypes().subscribe(
       data => { this.job_type_affidavit_types = data; },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  

   sendCourtID(id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.count = id;
    this.initialCount = id;
  // console.log('sending ID:' + this.count);
  
  }

  sendDocumentID(id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.count = id;
    this.initialCount = id;
  // console.log('sending ID:' + this.count);
  
  }

  sendAffidavitID(id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.count = id;
    this.initialCount = id;
  console.log('sending ID:' + this.count);
  
  }


  sendLocationID(id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.count = id;
    this.initialCount = id;
  // console.log('sending ID:' + this.count);
  
  }

  sendTypeID(id) {
    // this.initialCount = this.trace_candidates.trace_candidate_id;
    this.count = id;
    this.initialCount = id;
  // console.log('sending ID:' + this.count);
  
  }



}
